<template>
    <div id="secondary-info-modal" class="tw-px-8 lg:tw-px-10 tw-py-4">
      <div class="tw-flex tw-justify-center tw-mt-6">
        <img src="@/assets/img/info.svg" alt="info" />
      </div>
      <div class="tw-mt-6">
        <h3 class="tw-text-xl tw-text-center tw-font-bold">
          Market and Advanced Trading
        </h3>
      </div>
      <div class="tw-mt-8">
        <div class="tw-flex tw-font-bold tw-mb-1">
          <img class="tw-mr-4" src="@/assets/img/success-mark.svg" alt="info" />
          <h3>Market Trading</h3>
        </div>
        <p class="tw-text-black-light tw-text-sm tw-ml-9">
          A market order lets you buy or sell a token at the best currently
          available price. This means you can't be sure of the price your order
          will be executed.
        </p>
      </div>
      <div class="tw-mt-8">
        <div class="tw-flex tw-font-bold tw-mb-1">
          <img class="tw-mr-4" src="@/assets/img/success-mark.svg" alt="info" />
          <h3>Advanced Trading</h3>
        </div>
        <p class="tw-text-black-light tw-text-sm tw-ml-9">
          With advanced trading, you can place a buy or sell order in advance with
          a set price. The exchange will only fill your order at the set price or
          better.
        </p>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "SecondaryInfoModal",
  };
  </script>
  
  <style lang="scss" scoped></style>
  